module.exports = "/fonts/Roboto-Regular.eot";